import { useQueryClient } from '@tanstack/react-query';
import { useSocket } from '@/shared/api/use-socket';
import { WsTypes } from '@/shared/api/websocket-events';
import { invalidateStorageQueries } from './invalidate-storage-queries';

/** Mount once inside the application's QueryClientProvider. */
export const useCacheStorageSync = () => {
  const queryClient = useQueryClient();

  useSocket({
    type: WsTypes.CACHED_STORAGE_INVALIDATION,
    name: 'cache-storage',
    handler: ({ value }) => {
      const event: unknown = value?.type;
      if (typeof event !== 'string') return;
      return invalidateStorageQueries(queryClient, {
        predicate: (query) => query.meta?.cacheStorageEvent === event,
      });
    },
    onReconnect: () =>
      invalidateStorageQueries(queryClient, {
        predicate: (query) => typeof query.meta?.cacheStorageEvent === 'string',
      }),
  });
};